import { AppDoubleHeaderNavigationState } from '../../../initialStateRegistration';

const getFooter = (state: AppDoubleHeaderNavigationState) => state.footer;

export const getLinksSection = (state: AppDoubleHeaderNavigationState) => getFooter(state).linksSection;

export const getSocialSection = (state: AppDoubleHeaderNavigationState) => getFooter(state).oldSocialSection;

export const getAppsSection = (state: AppDoubleHeaderNavigationState) => getFooter(state).appsSection;

export const getBottomFooterBar = (state: AppDoubleHeaderNavigationState) => getFooter(state).bottomFooterBar;
